class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.delay = this.dataset.delay || 500;

    this.addEventListener('keyup', onKeyUpEscape);
    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    if (this.dataset.open == 'hover') {
      this.toggleOnHover();
    }
    this.mainDetailsToggle.addEventListener("mouseenter", this.renderFilter.bind(this));
  }

  renderFilter() {
    this.filterMenuElementList = this.querySelectorAll('filter-menu');
    this.filterMenuElementList.forEach(filterMenuElement => {
      if(filterMenuElement.hasAttribute('data-rendered')) return;
      const event = new CustomEvent('fetch-section-data');
      filterMenuElement.dispatchEvent(event);
    });


  }

  toggleOnHover() {
    let closeTimeout;
  
    this.mainDetailsToggle.addEventListener('mouseenter', () => {
      clearTimeout(closeTimeout);
      this.open();
    });
  
    this.mainDetailsToggle.addEventListener('mouseleave', () => {
      closeTimeout = setTimeout(() => this.close(), this.delay);
    });
  }

  open() {
    this.mainDetailsToggle.setAttribute('open', '');
    console.log('open');
  }

  onFocusOut() {
    if (this.dataset.alwaysOpen) return;
    console.log(this);
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open')
  }
}

customElements.define('details-disclosure', DetailsDisclosure);